import { useInvoices } from "@/contexts/InvoicesContext";
import { styles } from "@/pages/InvoicesPage.styles";
import type { SortArrowProps } from "@/types/ui";
import { SortDirection } from "@shared/types/payment";

const SortArrow = ({ column }: SortArrowProps) => {
  const { sort } = useInvoices();

  if (sort.column !== column) {
    return (
      <svg className={styles.sortIconInactive} viewBox="0 0 16 16" fill="currentColor">
        <path d="M8 3l5 7H3l5-7z M8 13l5-7H3l5-7z" opacity="0.3" />
      </svg>
    );
  }
  if (sort.direction === SortDirection.ASC) {
    return (
      <svg className={styles.sortIconAsc} viewBox="0 0 16 16" fill="currentColor">
        <path d="M8 3l5 7H3l5-7z" />
      </svg>
    );
  }
  return (
    <svg className={styles.sortIconDesc} viewBox="0 0 16 16" fill="currentColor">
      <path d="M8 13l5-7H3l5-7z" />
    </svg>
  );
};

export { SortArrow };
